<a
  (click)="tealiumLink($event)"
  angulartics2On="click"
  angularticsCategory="Outbound Clicks"
  angularticsEvent="Header Logo Image"
  [angularticsProperties]="{ label: 'Go Army' }"
  class="army-logo"
>
  <img class="goarmylink" src="/assets/images/army_logo1_rev_rgb.svg" alt="U.S. Army" />
</a>

<nav>
  <a
    angulartics2On="click"
    angularticsCategory="Internal Navigation"
    angularticsEvent="Header Nav"
    [angularticsProperties]="{ label: 'Edge' }"
    routerLink="/"
    routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: true }"
    >Overview</a
  >
  
  <a class="products" (mouseenter)="toggleProductDropdown($event)" (mouseleave)="toggleProductDropdown($event)">
    <span (touchstart)="toggleProductDropdown($event)" #productsTab>Products</span>
    
    <div class="dropdown">
      <a routerLink="/football" routerLinkActive="active">
        <p>Football</p> 
        <img src="/assets/images/football/football-menu-icon.svg" alt="Football">
      </a>
      <a routerLink="/vr" routerLinkActive="active">
        <p>Football VR</p> 
        <img src="/assets/images/vr/VR-icon.svg" alt="VR">
      </a>
      <a
        routerLink="/soccer"
        routerLinkActive="active">
        <p>Soccer</p> 
        <img src="/assets/images/soccer/soccer-menu-icon.svg" alt="Football">
      </a>
      <a routerLink="/fitness" routerLinkActive="active">
        <p>Fitness</p> 
        <img src="/assets/images/fitness/fitness-menu-icon.svg" alt="Fitness">
      </a>
    </div>
  </a>
  
  <a
    angulartics2On="click"
    angularticsCategory="Internal Navigation"
    angularticsEvent="Header Nav"
    [angularticsProperties]="{ label: 'Support' }"
    routerLink="/support"
    routerLinkActive="active"
    >Support</a
  >
  <a
    angulartics2On="click"
    angularticsCategory="Internal Navigation"
    angularticsEvent="Header Nav"
    [angularticsProperties]="{ label: 'Press' }"
    routerLink="/press"
    routerLinkActive="active"
    >Press</a
  >
  <a
    angulartics2On="click"
    angularticsCategory="Internal Navigation"
    angularticsEvent="Header Nav"
    [angularticsProperties]="{ label: 'Recruiter' }"
    href="//recruiter.goarmyedge.com/"
    >Recruiter</a
  >
</nav>

<edge-header-webplayer
  [class.dropdown-active]="showDropdown$ | async"
></edge-header-webplayer>

<span
  class="hamburger"
  aria-label="Open Mobile Menu"
  (click)="toggleMobileMenu(true)"
>
  <i></i>
</span>
